export default __webpack_public_path__ + "static/media/qrcodeBackground.77819bce.jpg";